import CsaTicketing from '../../CsaTicketing';
import PauseAction from '../components/Pause';
import Payments from '../components/Payments';
import FeedbackForm from '../feedbackForm';

export const TAB_KEYS = {
  FEEDBACK: 'feedback',
  PAYMENTS: 'payments',
  TASKS: 'tasks',
  PAUSE: 'pause'
};

export const LEFT_SIDE_TABS = [
  {
    key: TAB_KEYS.PAUSE,
    value: 'Pause',
    component: PauseAction,
    featureFlagKey: 'pauseCollectionEffortsFeatureFlag'
  },
  {
    key: TAB_KEYS.FEEDBACK,
    value: 'Feedback',
    component: FeedbackForm
  },
  {
    key: TAB_KEYS.PAYMENTS,
    value: 'Payments',
    component: Payments
  },
  {
    key: TAB_KEYS.TASKS,
    value: 'Tasks',
    component: CsaTicketing,
    featureFlagKey: 'csaCoOrdinationModuleFeatureFlag'
  }
];
